import {useI18n} from '../../../../contexts/I18n.client';
import {EnCustomizeAnimation} from './en/EnCustomizeAnimation';
import {IntCustomizeAnimation} from './int/IntCustomizeAnimation';

export const CustomizeAnimation = () => {
  const {language} = useI18n();

  return language === 'en' ? (
    <EnCustomizeAnimation />
  ) : (
    <IntCustomizeAnimation />
  );
};
